module.exports = __webpack_public_path__ + "static/media/Dee.e84162c3.png";